import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string;
  change: string;
  changeType: "increase" | "decrease";
  icon: LucideIcon;
  iconColor?: string;
  onClick?: () => void;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  changeType,
  icon: Icon,
  iconColor = "text-primary",
  onClick,
}) => {
  const isClickable = Boolean(onClick);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`rounded-lg border bg-card p-6 text-card-foreground shadow-sm transition ${
        isClickable
          ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-lg"
          : ""
      }`}
      onClick={onClick}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <h3 className="mt-2 text-2xl font-bold">{value}</h3>
          <div className="mt-2 flex items-center">
            <span
              className={`text-sm font-medium ${
                changeType === "increase" ? "text-success" : "text-destructive"
              }`}
            >
              {change}
            </span>
            <span className="ml-2 text-sm text-muted-foreground">
              from last month
            </span>
          </div>
        </div>
        <div
          className={`${iconColor} flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10`}
        >
          <Icon size={24} />
        </div>
      </div>
    </div>
  );
};
